var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1081_4998",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E4AB23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1081_4998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0184 3C12.231 3 12.435 3.07885 12.5854 3.2192C12.7357 3.35954 12.8202 3.5499 12.8202 3.74838H14.4239C14.6365 3.74838 14.8405 3.82723 14.9909 3.96758C15.1412 4.10793 15.2257 4.29828 15.2257 4.49676C15.2257 4.69525 15.1412 4.8856 14.9909 5.02595C14.8405 5.1663 14.6365 5.24514 14.4239 5.24514H4.80184C4.58918 5.24514 4.38523 5.1663 4.23485 5.02595C4.08448 4.8856 4 4.69525 4 4.49676C4 4.29828 4.08448 4.10793 4.23485 3.96758C4.38523 3.82723 4.58918 3.74838 4.80184 3.74838H6.40551C6.40551 3.5499 6.48999 3.35954 6.64036 3.2192C6.79074 3.07885 6.99469 3 7.20735 3H12.0184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74854 6.79932H14.4775V15.7799C14.4775 16.1769 14.3067 16.5576 14.0026 16.8383C13.6985 17.119 13.286 17.2767 12.856 17.2767H6.37003C5.93998 17.2767 5.52755 17.119 5.22346 16.8383C4.91937 16.5576 4.74854 16.1769 4.74854 15.7799V6.79932ZM7.58615 8.29608C7.47864 8.29608 7.37553 8.3355 7.29951 8.40568C7.22348 8.47585 7.18077 8.57103 7.18077 8.67027V15.4057C7.18077 15.5049 7.22348 15.6001 7.29951 15.6703C7.37553 15.7405 7.47864 15.7799 7.58615 15.7799C7.69366 15.7799 7.79677 15.7405 7.87279 15.6703C7.94881 15.6001 7.99152 15.5049 7.99152 15.4057V8.67027C7.99152 8.57103 7.94881 8.47585 7.87279 8.40568C7.79677 8.3355 7.69366 8.29608 7.58615 8.29608ZM11.6399 8.29608C11.5324 8.29608 11.4293 8.3355 11.3532 8.40568C11.2772 8.47585 11.2345 8.57103 11.2345 8.67027V15.4057C11.2345 15.5049 11.2772 15.6001 11.3532 15.6703C11.4293 15.7405 11.5324 15.7799 11.6399 15.7799C11.7474 15.7799 11.8505 15.7405 11.9265 15.6703C12.0025 15.6001 12.0453 15.5049 12.0453 15.4057V8.67027C12.0453 8.57103 12.0025 8.47585 11.9265 8.40568C11.8505 8.3355 11.7474 8.29608 11.6399 8.29608Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhiteIcon);
export default __webpack_public_path__ + "static/media/delete_white_icon.48cdf66d750a79a68fd419d7899056c5.svg";
export { ForwardRef as ReactComponent };